import { type AnyAction } from 'redux';

export const addReducerIdToAction = <TAction extends AnyAction = AnyAction>(action: TAction, reducerId: string) => {
    const newAction = { ...action };

    if (action.type) {
        newAction.type = action.type + reducerId;
    }

    return newAction;
};

let counter = 0;

export const getReducerUniqueId = (prefix = '') => prefix + counter++;
